module.exports = __webpack_public_path__ + "img/Pay-your-TradeMark-Registration.54f0059c.jpg";